module.exports = __webpack_public_path__ + "img/loyalty-title.db4170c3.svg";